export default {
  convRate: 20,
  convCap: 24,
};
